import React from "react";
import Forbidden from "./Forbidden";

interface PermissionGateProps {
  allowed?: boolean;
  children: React.ReactNode;
}

const PermissionGate: React.FC<PermissionGateProps> = ({ allowed = false, children }) => {
  if (!allowed) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

export default PermissionGate;
